import {stockEasyOffer} from "domain/enum/offers";

export const DEFAULT_PRODUCT_LIST_FILTERS = ["status=true", "validated=true", "exists[eshopId]=true", "inStock=true"];
export const DEFAULT_VARIATION_LIST_FILTERS = ["status=true", "validated=true", "exists[eshopId]=true", "stock[gt]=0"];

export function defaultProductListFilters(offer) {
    return offer === stockEasyOffer ? [] : DEFAULT_PRODUCT_LIST_FILTERS;
}

export function defaultVariationListFilters(offer) {
    return offer === stockEasyOffer ? [] : DEFAULT_VARIATION_LIST_FILTERS;
}
